export default {
  methods: {
    singular(name, capitalize) {
      if (name === 'albums') {
        name = 'album';
      } else if (name === 'categories') {
        name = 'category';
      } else if (name === 'galleries') {
        name = 'gallery';
      } else if (name === 'photos') {
        name = 'photo';
      }
      if (capitalize) {
        name = name.charAt(0).toUpperCase() + name.slice(1);
      }
      return name;
    },
    plural(name, capitalize) {
      if (name === 'album') {
        name = 'albums';
      } else if (name === 'category') {
        name = 'categories';
      } else if (name === 'gallery') {
        name = 'galleries';
      } else if (name === 'photo') {
        name = 'photos';
      }
      if (capitalize === 'capitalize') {
        name = name.charAt(0).toUpperCase() + name.slice(1);
      }
      return name;
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/pluralSingular.js